var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inspection-form-section-list',{attrs:{"inspectionForm":_vm.inspectionForm},on:{"onChangeInspectionForm":_vm.inspectionFormChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }